import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { GatsbyImage } from "gatsby-plugin-image";
import { fullWidth } from "components/Design/ArtDirectedImage";
import HOTEL_PROPERTY_BALI_URL from "dictionaries/hotelBali";

import Drawer from "components/Design/Drawer/Drawer";
import DrawerHead from "components/Design/Drawer/DrawerHead";
import ConditionalLink from "components/ConditionalLink";

const HotelSelectionDrawer = ({ visible, close, content }) => {
  const { t } = useTranslation("homepage");

  return (
    <Drawer visible={visible} placement="bottom">
      <div className="absolute top-0 left-0 w-full z-1">
        <DrawerHead
          title={<div className="text-h5">{t("Hotels")}</div>}
          onClose={close}
        />
      </div>
      <div className="h-full overflow-auto pt-60">
        <div className="px-20 pb-20">
          <div className="font-mulish pt-20 mb-16">
            {content?.map((item) => {
              return (
                <div className="text-center pb-24">
                  <ConditionalLink
                    link={HOTEL_PROPERTY_BALI_URL[item.name]}
                    className="block">
                    <div className="block p-10 border-b border-gray-light">
                      <GatsbyImage
                        image={fullWidth(item.logo)}
                        className="w-120 h-120 mx-auto"
                        loading="lazy"
                      />
                    </div>
                  </ConditionalLink>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Drawer>
  );
};

HotelSelectionDrawer.defaultProps = {
  content: {},
};

export default HotelSelectionDrawer;
